import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {Observable, map, finalize} from "rxjs";
import { LoaderService } from "./loader.service";
import { ActionResult, ActionResultList, RoleEdit, UserDetail } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class OrganiserUsersService {
  static readonly USER_NOT_FOUND: number = 21;
  static readonly USER_ALREADY_ASSIGNED: number = 22;
  static readonly USER_ROLE_CHANGE_NOT_ALLOWED: number = 23;

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  findUsers(organiserId?: number): Observable<UserDetail[]> {
    return this.http.post<ActionResultList<UserDetail[], number>>(
      `${this.environmentService.getApiUrl()}/api/organiser/users`,
      organiserId ?? null
    ).pipe(
      map(value => value?.result?.length ? value.result : [])
    );
  }

  addUser(email: string, roleId: number, organiserId?: number): Observable<ActionResult<boolean>> {
    const roleEdit = new RoleEdit(email, undefined, roleId, organiserId);
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(
      `${this.environmentService.getApiUrl()}/api/organiser/users/add`,
      roleEdit
    ).pipe(
        finalize(() => this.loaderService.dismissLoading())
    );
  }

  editUser(userId: number, roleId: number, organiserId?: number): Observable<ActionResult<boolean>> {
    const roleEdit = new RoleEdit(undefined, userId, roleId, organiserId);
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(
      `${this.environmentService.getApiUrl()}/api/organiser/users/edit`,
      roleEdit
    ).pipe(finalize(() => this.loaderService.dismissLoading()));
  }

  deleteUser(userId: number, organiserId?: number): Observable<ActionResult<boolean>> {
    const roleEdit = new RoleEdit(undefined, userId, undefined, organiserId);
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(
      `${this.environmentService.getApiUrl()}/api/organiser/users/remove`,
      roleEdit
    ).pipe(finalize(() => this.loaderService.dismissLoading()));
  }
}
